<template lang="pug">
  b-container(fluid)
    b-table.card-table.scrollable-area.max-h-250.mb-0(:items="billings", :fields="fields", responsive, show-empty)
      template(v-slot:empty)
        p.text-help.mb-0 No hay historial de planes
      template(v-slot:cell(index)="{ index }")
        p.mb-0.text-help {{ index + 1 }}
      template(v-slot:cell(start_date)="{ item }")
        p.mb-0 {{ $moment(item.start_date).format('DD-MMM-YY') }}
      template(v-slot:cell(end_date)="{ item }")
        p.mb-0 {{ $moment(item.end_date).format('DD-MMM-YY') }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const planController = createNamespacedHelpers('plan')

export default {
  data () {
    return {
      fields: [
        {
          key: 'index',
          label: '#'
        },
        {
          key: 'plan_name',
          label: 'Plan'
        },
        {
          key: 'status',
          label: 'Estado'
        },
        {
          key: 'start_date',
          label: 'Fehca inicio'
        },
        {
          key: 'end_date',
          label: 'Fecha fin'
        },
        {
          key: 'expire_date_string',
          label: 'Vencimiento'
        }
      ],
      billings: []
    }
  },
  computed: {
    ...planController.mapState({
      plans: state => state.plans
    }),
  },
  methods: {
    ...mapActions(['account/billings']),
    getAccountBilling() {
      let self = this
      // this.showLoadingScreen()

      this['account/billings']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.billings = res.resource.map(bill => {

              let plan = self.plans.find(p => p.plan_id == bill.plan_id)
              bill.plan_name = plan ? plan.name : `Plan ${bill.plan_id}`

              bill.end_date = self.$moment(bill.start_date).add(bill.billed_days, 'days')

              let expire_date = bill.end_date,
                diff_days = self.$moment().diff(expire_date, 'days'),
                diff_months = self.$moment().diff(expire_date, 'months'),
                diff_years = self.$moment().diff(expire_date, 'years')


              if (diff_days == 0) { // is today
                bill.expire_date_string = 'Hoy vence tu plan'
              } else if (diff_days < 0) { // is in the future
                if ((diff_days * -1) > 730) { // min 2 years
                  bill.expire_date_string = `Vence en ${diff_years * -1} años`
                } else if ((diff_days * -1) > 62) { // min 2 months
                  bill.expire_date_string = `Vence en ${diff_months * -1} meses`
                } else { // days left
                  bill.expire_date_string = `Vence en ${diff_days * -1} días`
                }
              } else { // is in the past
                bill.expire_date_string = `Terminó hace ${diff_days} días`
              }

              return bill
            })
          }
        }
      })
    },
  },
  mounted () {
    this.getAccountBilling()
  }
}
</script>

<style lang="scss" scoped>
</style>
